import Fn from "jj-browser-fn";
import cookies from "./cookie";
import storage from "./storage";
import md5 from "js-md5";
import { footprint } from "@/req/operation";
import { collect, competitionCollect, boxCollect } from "./server";
// import { apiTokenList } from "@/config/bdApi/bdToken";
import { playTimes } from "@/req/competitionEvent";
import CryptoJS from "crypto-js";
import bPoint from "@/utils/bPoint";
import { Burying } from "./Burying";

const collectKey = process.env.VUE_APP_COLLECT_KEY; // collect
interface CollectData {
  i?: string; // 事件id
  d?: string; // 收集数据 json 包含uid
  t?: string; // 时间戳【13位，毫秒】
}
const sign = collectKey;

const userCirculation = (obj) => {
  for (const y in obj) {
    if (true) {
      if (obj[y] == "" || obj[y] == null || obj[y] == undefined) {
        delete obj[y];
      }
    }
  }
  return obj;
};

const ProjFn = {
  ...Fn,
  cookies,
  storage,
  // 跳转游戏详情
  toGameDetail: (gameid, types, uid) => {
    window.App.$router.push({
      path: "/myGame/gameDetail",
      query: { id: gameid, type: types, uids: uid },
    });
  },
  // 跳转直播间
  toStudioRoom: (routePath, liveId, isCompetition) => {
    // 是否赛事直播
    if (isCompetition) {
      window.App.$router.push({
        path: "/competition",
        query: { type: "1", id: liveId },
      });
    } else {
      window.App.$router.push({
        path: "/studio",
        query: { type: "1", id: liveId },
      });
    }
  },
  // 转换成时间
  toTimes: (time) => {
    if (!time) {
      return "";
    } else {
      const date = new Date(time * 1000);
      const dateNumFun = (num) => (num < 10 ? `0${num}` : num);
      const [Y, M, D, h, m, s] = [
        date.getFullYear(),
        dateNumFun(date.getMonth() + 1),
        dateNumFun(date.getDate()),
        dateNumFun(date.getHours()),
        dateNumFun(date.getMinutes()),
        dateNumFun(date.getSeconds()),
      ];
      return `${Y}-${M}-${D} ${h}:${m}:${s}`;
    }
  },
  toDates: (time) => {
    if (!time) {
      return "";
    } else {
      const date = new Date(time * 1000);
      const dateNumFun = (num) => (num < 10 ? `${num}` : num);
      const [Y, M, D, h, m, s] = [
        date.getFullYear(),
        dateNumFun(date.getMonth() + 1),
        dateNumFun(date.getDate()),
        dateNumFun(date.getHours()),
        dateNumFun(date.getMinutes()),
        dateNumFun(date.getSeconds()),
      ];
      return `${M}月${D}日`;
    }
  },
  toDateSymbol: (time) => {
    if (!time) {
      return "";
    } else {
      const date = new Date(time * 1000);
      const dateNumFun = (num) => (num < 10 ? `0${num}` : num);
      const [Y, M, D, h, m, s] = [
        date.getFullYear(),
        dateNumFun(date.getMonth() + 1),
        dateNumFun(date.getDate()),
        dateNumFun(date.getHours()),
        dateNumFun(date.getMinutes()),
        dateNumFun(date.getSeconds()),
      ];
      return `${M}-${D} ${h}:${m}`;
    }
  },
  // 超出3字符省略号
  ellipsis: (value: any) => {
    if (!value) return "";
    if (value.length > 3) {
      return value.slice(0, 3) + "...";
    }
    return value;
  },
  // 游戏热度
  hotEllipsis: (item: any) => {
    const value = item + "";
    if (!value) return "";
    if (value.length == 5) {
      return value.slice(0, 1) + "w+";
    }
    if (value.length == 6) {
      return value.slice(0, 2) + "w+";
    }
    if (value.length >= 7) {
      return value.slice(0, 0) + "99w+";
    }
    return value;
  },
  random: () => {
    const chars = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ];
    let res = "";
    for (let i = 0; i < 32; i++) {
      const id = Math.ceil(Math.random() * 35);
      res += chars[id];
    }
    return res;
  },
  // 接口验签；meta 可传入与 V3 共用的 rqtime / rqrandom
  toSign: (obj, url, signObj?, meta?: { rqtime?: number | string; rqrandom?: string }) => {
    // 按照升序排序obj属性
    const sortObj = obj;
    // 生成随机数（若 http 层已生成则复用，保证与 X-BOX-AUTHORIZATION NONCE 一致）
    const chars = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ];
    let resNum = (meta && meta.rqrandom) || "";
    if (!resNum) {
      for (let i = 0; i < 32; i++) {
        const id = Math.ceil(Math.random() * 35);
        resNum += chars[id];
      }
    }
    const newkey = Object.keys(sortObj).sort();
    const newObj: any = {};
    newkey.forEach((item, i) => {
      // 遍历newkey数组
      newObj[newkey[i]] = sortObj[newkey[i]];
      // 向新创建的对象中按照排好的顺序依次增加键值对
    });
    // const token = newObj.token;
    delete newObj.token;
    const keyArr = new Array();
    for (const y in newObj) {
      if (true) {
        const x = newObj[y];
        keyArr.push(x);
      }
    }
    newObj.rqtime =
      meta && meta.rqtime != null && meta.rqtime !== ""
        ? Number(meta.rqtime)
        : Date.parse(String(new Date()));
    newObj.rqrandom = resNum;
    const signKey = process.env.VUE_APP_SIGN_KEY_501
    // 有 signObj：values + rqtime + rqrandom + key（对齐活动）
    // 无 signObj：values + key + rqtime + rqrandom
    if (signObj) {
      keyArr.push(newObj.rqtime);
      keyArr.push(newObj.rqrandom);
      keyArr.push(signKey);
    } else {
      keyArr.push(signKey);
      keyArr.push(newObj.rqtime);
      keyArr.push(newObj.rqrandom);
    }
    let sginStr = "";
    keyArr.filter((item) => {
      if (typeof item == "object") {
        return JSON.stringify(item);
      }
    });
    // 将字符串按验签规则拼接（object 累加，对齐活动）
    for (const y in keyArr) {
      if (true) {
        if (typeof keyArr[y] == "object" && keyArr[y] != null) {
          sginStr = sginStr + JSON.stringify(keyArr[y]);
        } else if (keyArr[y] == undefined || keyArr[y] == null) {
          sginStr = sginStr;
        } else {
          sginStr = sginStr + keyArr[y];
        }
      }
    }
    // appv >= 5.0.1 验签串需带 box-agent（对齐分享页）
    if (signObj && ProjFn.getBoxVersion(signObj.appv) >= 501) {
      const value = `appv=${signObj.appv}&device=${signObj.device}&deviceId=${
        signObj.deviceId
      }&box-agent=${ProjFn.headerBoxAgent(signObj)}&${sginStr}`;
      newObj.sign = md5(value);
    } else {
      newObj.sign = md5(sginStr);
    }
    // newObj.token = token;
    return newObj;
  },
  // 埋点用户行为记录
  // module_index 模块索引编号
  // deed   1=打开,2=点击,3=输入,4=关闭,10=返回
  // relation_id  操作关联的ID
  userRecord: async (moduleIndex, deed, relationId) => {
    return false;
    const obj = {
      module_index: moduleIndex ? moduleIndex : "",
      deed: deed ? deed : "",
      relation_id: relationId ? relationId : "",
    };
    const res = await footprint(obj);
  },
  // 赛事埋点
  competitionRecord: async (
    firstEvent,
    secondEvent,
    threeEvent,
    liveId,
    channerId,
  ) => {
    const date = new Date();
    const dateNumFun = (num) => (num < 10 ? `0${num}` : num);
    const [Y, M, D, h, m, s] = [
      date.getFullYear(),
      dateNumFun(date.getMonth() + 1),
      dateNumFun(date.getDate()),
      dateNumFun(date.getHours()),
      dateNumFun(date.getMinutes()),
      dateNumFun(date.getSeconds()),
    ];
    const time = `${Y}-${M}-${D} ${h}:${m}:${s}`;
    const obj = {
      created_at: time,
      device: "pc",
      appv: localStorage.getItem("appv")
        ? localStorage.getItem("appv")
        : "5.1.0",
      first_event: firstEvent ? firstEvent : "",
      series: secondEvent ? secondEvent : "",
      three_event: threeEvent ? threeEvent : 0,
      user_id: window.App.$store.state.user.info.id
        ? window.App.$store.state.user.info.id
        : 0,
      live_no: liveId ? liveId : "",
      platform: channerId ? channerId : "",
    };
    const resObj = await competitionCollect(userCirculation(obj));
  },
  // 赛事h5、视频回放、精彩瞬间点击报点
  getPlayTimes: async (type, ids) => {
    const obj: any = {
      token: cookies.getToken(),
      id: ids,
      jump_type: type,
    };
    const res = await playTimes(obj);
  },
  getContentImg: (content) => {
    let imgArr = [];
    if (!content) return imgArr;
    if (content.match(/<img\b.*?(?:\>|\/>)/g)) {
      imgArr = content
        .match(/<img\b.*?(?:\>|\/>)/g)
        .map((item) =>
          JSON.parse(
            item
              .match(/\bsrc\b\s*=\s*[\'\"]?([^\'\"]*)[\'\"]?/g)[0]
              .replace("src=", ""),
          ),
        );
    }
    imgArr = imgArr.filter((item) => item);
    return imgArr;
  },
  getbdVidLink: (url, bdVid, apiToken) => {
    const bdLink = url.replace(".exe", "") + `&${bdVid}#${apiToken}&` + ".exe";
    return bdLink;
  },
  get360Link: (url, qhclickId, data) => {
    const bdLink =
      url.replace(".exe", "") +
      `&${qhclickId}#${data.key}#${data.Secret}#${data.IDX}&` +
      ".exe";
    return bdLink;
  },
  /**
   * 拼参带 gameId：下载后跳转对应游戏详情(gamech)
   * 百度: bdVid#apiToken#gameId#gamech
   * 360广告: clickId#key#Secret#IDX#gameId#gamech#1
   * 360搜索: clickId#key#Secret#gameId#gamech#1
   * aqylk/yklk/sougoulk/msclk: clickId#key#1#gameId#gamech#1
   */
  getGamechLink: (url, clickId, data, gameId) => {
    // 无买量 clickId（bd_vid / msclkid 等）时，统一兜底：1#1#1#gameId#gamech#1
    if (!clickId) {
      return (
        url.replace(".exe", "") + `&1#1#1#${gameId}#gamech#1&` + ".exe"
      );
    }
    const id = clickId;
    const channelKeys = ["aqylk", "yklk", "sougoulk", "msclk"];
    let suffix = "";
    if (data && data.isBaiduApiToken) {
      suffix = `${id}#${data.isBaiduApiToken}#${gameId}#gamech`;
    } else if (data && data.key && channelKeys.includes(String(data.key))) {
      suffix = `${id}#${data.key}#1#${gameId}#gamech#1`;
    } else if (
      data &&
      data.key &&
      data.Secret &&
      data.IDX !== undefined &&
      data.IDX !== null &&
      data.IDX !== ""
    ) {
      suffix = `${id}#${data.key}#${data.Secret}#${data.IDX}#${gameId}#gamech#1`;
    } else if (data && data.key && data.Secret) {
      suffix = `${id}#${data.key}#${data.Secret}#${gameId}#gamech#1`;
    } else {
      suffix = `1#1#1#${gameId}#gamech#1`;
    }
    return url.replace(".exe", "") + `&${suffix}&` + ".exe";
  },
  toCollectSign: (obj: any) => {
    // 按照升序排序obj属性
    const sortObj: CollectData = {};
    sortObj.i = obj.id;
    sortObj.t = String(Date.parse(String(new Date())));
    sortObj.d = JSON.stringify({
      uid: 0,
    });
    const newkey = Object.keys(sortObj).sort();
    const newObj: any = {};
    newkey.forEach((item, i) => {
      // 遍历newkey数组
      newObj[newkey[i]] = sortObj[newkey[i]];
      // 向新创建的对象中按照排好的顺序依次增加键值对
    });
    const keyArr: any = [];
    for (const y in newObj) {
      if (true) {
        const x = newObj[y];
        if (typeof newObj[y] === "object") {
          keyArr.push(y + "=" + JSON.stringify(x.map(String)));
        } else {
          keyArr.push(y + "=" + x);
        }
      }
    }
    const keySign = keyArr.join("&");
    const result = CryptoJS.HmacSHA1(keySign, sign).toString(CryptoJS.enc.Hex);
    newObj.sign = result;
    return newObj;
  },
  boxCollect: async (idx: string) => {
    const res = await boxCollect({ id: idx });
  },
  // 996魔方埋点上报
  boxSDKCollectChange: async (I, obj?: any) => {
    let keyObj = {};
    if (obj) {
      keyObj = JSON.parse(JSON.stringify(obj));
    }
    ProjFn.sdkBoxCollect(I, keyObj);
  },
  // sdk埋点(996魔方)
  sdkBoxCollect(ch, key) {
    const userState =
      window.App &&
      window.App.$store &&
      window.App.$store.state &&
      window.App.$store.state.user;
    const userInfo = userState && userState.info;
    const userId = userInfo && userInfo.id ? userInfo.id : 0;
    const data = {
      eventname: ch,
      eventtype: "track",
      uid: userId,
      properities: {
        user_id: String(userId),
        ...key,
      },
    };
    Burying(data);
  },
  bPoint: (params) => {
    bPoint(params);
  },
  headerBoxAgent(obj: any) {
    const param = Object.keys(obj);
    const data = Object.values(obj);
    let s = "";
    param.forEach((item, index) => {
      const val = data[index] === undefined ? "" : data[index];
      s += `${item}:${val};`;
    });
    return s;
  },
  getBoxVersion(v) {
    const appv: any = v ? v : "5.1.0";
    const strVersion: any = appv.replace(/&.+/, "");
    const numVersion = strVersion.replace(/[^0-9]/g, "");
    const mainVersion = numVersion.slice(0, 3);
    return Number(mainVersion);
  },
};

export default ProjFn;
